// Initialize AOS
document.addEventListener("DOMContentLoaded", function () {
	AOS.init();
});

$(document).ready(function () {
	// Toggle menu icon
	$("#nav-icon4").on("click", function () {
		$(this).toggleClass("open");
	});

	// Scroll events (combined)
	$(window).on("scroll", function () {
		let scrollTop = $(this).scrollTop();

		// Fade out arrow
		$(".scroll-arrow").css("opacity", 1 - scrollTop / 700);

		// Navbar resize
		if (scrollTop > 80) {
			$("#navbar-ul").css("margin-top", "0px");
			$("#navbar-logo").css({
				width: "75px",
				transition: "0.2s",
			});
		} else {
			$("#navbar-ul").css("margin-top", "30px");
			$("#navbar-logo").css({
				width: "150px",
				transition: "0.2s",
			});
		}
	});

	$(".home-slide-bg").slick({
		arrows: false,
		fade: true,
		autoplay: true,
		autoplaySpeed: 5000,
		cssEase: "linear",
		pauseOnHover: false,
	});
});

$(function () {
	$(".gallery-item").slice(0, 4).show();

	$("#loadMore").on("click", function (e) {
		e.preventDefault();

		$(".gallery-item:hidden").slice(0, 4).slideDown();

		if ($(".gallery-item:hidden").length === 0) {
			$(this).fadeOut("slow");
		}

		$("html, body").animate(
			{
				scrollTop: $(this).offset().top,
			},
			800,
		);
	});
});
